<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';
import FormForgotPassword from './form-forgot-password';

export default {
  name: 'page-login',
  mixins: [
    PageProps,
  ],
  components: {
    FormForgotPassword,
  },
  computed: {
    AuthenticationForgotPassword() {
      return this.$store.getters.AuthenticationForgotPassword;
    },
  },
  methods: {
    ...mapActions([
      'SendAuthenticationForgotPassword',
    ]),
    onChangeLanguage(value) {
      this.$locale.change(value);
    },
    onFormSubmit(payload) {
      this.SendAuthenticationForgotPassword({
        payload,
      }).then(() => {
        this.successNotification({ message: 'message.success_forgot_password_recovery_email' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ message: 'message.error_forgot_password_recovery_email' });
      });
    },
  },
  beforeDestroy() {
    this.$store.dispatch('ClearAuthenticationForgotPassword');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/forgot-password/page-forgot-password.vue